import User from "../components/user/User";
import { PERMISSIONS } from "../configs/constants";
import { useAuthenticationHook } from "../app/useAuthenticationHook";

const Users = (): JSX.Element => {
  // 権限制御
  useAuthenticationHook(PERMISSIONS.ACCOUNT);
  return <User />;
};

export default Users;
